import { cozyCornersPostGrid } from "../../../mocks/inspirations";

export default function CCPostGrid() {
  return (
    <section id="cozy-grid" className="py-24 bg-[#F5F1E8]">
      <div className="max-w-screen-xl mx-auto px-8 md:px-16">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p
              className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              From the Journal
            </p>
            <h2
              className="text-[#2C2825] text-3xl md:text-4xl"
              style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
            >
              Latest Cozy Corner<br />
              <em>Inspiration</em>
            </h2>
          </div>
          <p
            className="text-[#8B8378] text-sm leading-relaxed max-w-xs"
            style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
          >
            Save, revisit, and get inspired by peaceful corners from the journal.
          </p>
        </div>

        {/* Grid — large first + two stacked, then three equal */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 mb-12">
          {/* Big feature card */}
          <div className="md:col-span-5 group cursor-pointer">
            <div className="relative overflow-hidden rounded-2xl bg-[#EDE6DA] aspect-[3/4]">
              <img
                src={cozyCornersPostGrid[0].image}
                alt={cozyCornersPostGrid[0].title}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent" />
              <div className="absolute top-5 left-5">
                <span
                  className="bg-[#FAF7F0]/90 text-[#6B5E53] text-[9px] px-3 py-1.5 rounded-full tracking-wider"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {cozyCornersPostGrid[0].category}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-7">
                <h3
                  className="text-white text-xl md:text-2xl leading-snug group-hover:text-[#EDE6DA] transition-colors"
                  style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
                >
                  {cozyCornersPostGrid[0].title}
                </h3>
                <p
                  className="text-white/65 text-sm mt-2"
                  style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
                >
                  {cozyCornersPostGrid[0].excerpt}
                </p>
              </div>
            </div>
          </div>

          {/* Middle stacked */}
          <div className="md:col-span-7 grid grid-rows-2 gap-5">
            {cozyCornersPostGrid.slice(1, 3).map((post) => (
              <div key={post.id} className="group cursor-pointer">
                <div className="relative overflow-hidden rounded-2xl bg-[#EDE6DA] h-full min-h-[220px]">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
                  <div className="absolute top-4 left-4">
                    <span
                      className="bg-[#FAF7F0]/85 text-[#6B5E53] text-[9px] px-3 py-1 rounded-full tracking-wider"
                      style={{ fontFamily: "'Inter', sans-serif" }}
                    >
                      {post.category}
                    </span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-5">
                    <h3
                      className="text-white text-lg leading-snug group-hover:text-[#EDE6DA] transition-colors"
                      style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
                    >
                      {post.title}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom row */}
          {cozyCornersPostGrid.slice(3).map((post) => (
            <div key={post.id} className="md:col-span-4 group cursor-pointer">
              <div className="relative overflow-hidden rounded-2xl bg-[#EDE6DA] aspect-[5/4]">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
                <div className="absolute top-4 left-4">
                  <span
                    className="bg-[#FAF7F0]/85 text-[#6B5E53] text-[9px] px-3 py-1 rounded-full tracking-wider"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {post.category}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3
                    className="text-white text-base leading-snug group-hover:text-[#EDE6DA] transition-colors"
                    style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
                  >
                    {post.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            className="inline-flex items-center gap-2.5 border border-[#C8BAA8] text-[#6B5E53] px-10 py-3.5 rounded-full text-xs tracking-[0.18em] hover:bg-[#2C2825] hover:text-white hover:border-[#2C2825] transition-all duration-300 cursor-pointer whitespace-nowrap uppercase"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            See More Corners
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs" />
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}
